/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Other_CitiesInputs */

const en_directory_other_cities = /** @type {(inputs: Directory_Other_CitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Other cities`)
};

const pl_directory_other_cities = /** @type {(inputs: Directory_Other_CitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inne miasta`)
};

/**
* | output |
* | --- |
* | "Other cities" |
*
* @param {Directory_Other_CitiesInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const directory_other_cities = /** @type {((inputs?: Directory_Other_CitiesInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Other_CitiesInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_directory_other_cities(inputs)
	return en_directory_other_cities(inputs)
});